export const theme = {

  colors: {
    primary: '#C66F4E',      // terracota NIDO
    secondary: '#2F7088',    // azul NIDO
    accent: '#F2A33B',       // naranja vital
    background: '#F7F6F1',  // marfil luminoso
    surface: '#FCFBF8',

    text: '#24353B',
    muted: '#69777A',

    border: '#DDE5E4',

    hover: '#EAF2F3'
  },

  typography: {

    fontFamily: "'Space Grotesk', system-ui, sans-serif",

    fontWeights: {
      regular: 400,
      medium: 500,
      semiBold: 600,
      bold: 700,
    },

    sizes: {
      xs: '0.75rem',
      small: '0.875rem',
      body: '1rem',
      medium: '1.125rem',
      large: '1.5rem',
      xl: '2rem',
      xxl: '2.5rem',
    },

    lineHeights: {
      tight: 1.2,
      normal: 1.5,
      relaxed: 1.7,
    },

  },

  spacing: {
    xs: '4px',
    sm: '8px',
    md: '12px',
    lg: '16px',
    xl: '24px',
    xxl: '32px'
  },

  radius: {
    small: '2px',
    medium: '4px',
    large: '8px',
    pill: '999px'
  },

  shadows: {
    soft: '0 8px 28px rgba(42,64,70,0.045)',
    card: '0 18px 50px rgba(42,64,70,0.075)',
    floating: '0 28px 80px rgba(42,64,70,0.13)'
  },

  transitions: {
    fast: 'all .15s ease',
    normal: 'all .25s ease'
  }

};
